import { Button, Drawer, message } from 'antd';
import { useEffect, useState } from 'react';
import { DiagnosticService } from 'services/DiagnosticService';

function DiagnosticResult({ visible, drawerClose, activeRecord }) {
  const [jsonObject, setJsonObject] = useState({
    actualRegData: { flRegData: {}, ulRegData: {} },
    byDoneForm: '',
    today: '',
    taxDebt: {},
    journal: {},
    saldos: {},
  });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (activeRecord) {
      const jsonObjects = JSON.parse(activeRecord?.post_data);
      setJsonObject(jsonObjects);
    }
  }, [activeRecord]);

  const downloadPDF = async () => {
    try {
      setLoading(true);

      const text = `
	  	<!DOCTYPE html>
<html lang="en">
	<head>
		<meta charset="UTF-8" />
		<meta name="viewport" content="width=device-width, initial-scale=1.0" />
		<title>Document</title>
	</head>
	<body>
		<style type="text/css">
			* {
  				font-family: 'Times New Roman', Times, serif;
				padding: 0;
				margin: 0;
				box-sizing: border-box;
			}
			
		</style>
		<div>
			<p style="margin-top: 1pt; margin-bottom: 1pt; font-size: 26pt">
				<strong><span style="color: #00b0f0">Диагностика</span></strong>
			</p>
			<table
				cellspacing="0"
				cellpadding="0"
				style="width: 100%; border-collapse: collapse"
			>
				<tr>
					<td
						style="
							width: 95.85pt;
							border-top: 2.25pt solid #ffffff;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
							background-color: #0070c0;
							padding: 4px;
						"
					>
						<h1
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff"
								>Наименование компании</span
							>
						</h1>
					</td>
					<td
						style="
							width: 150.27pt;
							border-top: 2.25pt solid #ffffff;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding-top: 0.7pt;
							padding-right: 9.68pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
                padding: 4px;
							"
						>
							   ${jsonObject?.actualRegData?.regData?.names?.ru.name ?? ''}
						</p>
					</td>
					<td
						style="
							width: 97.8pt;
							border-top: 2.25pt solid #ffffff;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
							background-color: #0070c0;
							padding: 4px;
						"
					>
						<h1
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">Руководитель</span>
						</h1>
					</td>
					<td
						style="
							width: 194.4pt;
							border-top: 2.25pt solid #ffffff;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
                padding: 4px;
							"
						>
 ${
   jsonObject?.actualRegData?.regData?.names?.ru?.fio !== ''
     ? jsonObject?.actualRegData?.regData?.names?.ru?.fio
     : jsonObject?.actualRegData?.regData?.ulRegData?.director?.nameRu
 }						</p>
					</td>
				</tr>
				<tr>
					<td
						style="
							width: 95.85pt;
							border: 2.25pt solid #ffffff;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
							background-color: #0070c0;
							padding: 4px;
						"
					>
						<h1
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">ИИН/БИН</span>
						</h1>
					</td>
					<td
						style="
							width: 150.27pt;
							border: 2.25pt solid #ffffff;
							padding-top: 0.7pt;
							padding-right: 9.68pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
                padding: 4px;
							"
						>
							  ${jsonObject?.actualRegData?.regData?.iin}
						</p>
					</td>
					<td
						style="
							width: 97.8pt;
							border: 2.25pt solid #ffffff;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
							background-color: #0070c0;
							padding: 4px;

						"
					>
						<h1
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff"
								>Режим налогообложения</span
							>
						</h1>
					</td>
					<td
						style="
							width: 194.4pt;
							border: 2.25pt solid #ffffff;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
                				padding: 4px;
							"
						>
							${jsonObject?.tax_regim}
						</p>
					</td>
				</tr>
			</table>
 			<p style="margin-top: 1pt; margin-bottom: 1pt; font-size: 12pt">
  <strong>
    <span style="color: #00b0f0">&#xa0;</span>
  </strong>
</p>
			<p style="margin-top: 1pt; margin-bottom: 1pt; font-size: 12pt">
				<strong
					><span style="color: #00b0f0"
						>Результат диагностики</span
					></strong
				>
			</p>
			
			<table
				cellspacing="0"
				cellpadding="0"
				style="
					width: 100%;
					border: 2.25pt solid #ffffff;
					border-collapse: collapse;
				"
			>
				<tr style="height: 1.35pt">
					<td
						style="
							width: 96.7pt;
							border-right: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<h1
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">Категория</span>
						</h1>
					</td>
					<td
						style="
							width: 70.25pt;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<h1
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">Статус</span>
						</h1>
					</td>
					<td
						style="
							width: 357.65pt;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<h1
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">Сведения</span>
						</h1>
					</td>
				</tr>
				${jsonObject?.results
          ?.map(
            (i) =>
              `
            <tr>
					<td
						style="
							width: 96.7pt;
							margin-top: 2px;
							border-top: 2.25pt solid #ffffff;
							border-right: 2.25pt solid #ffffff;
							border-bottom: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<h1
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							<span style="color: #00b0f0">${i.category ?? ''}</span>
						</h1>
					</td>
					<td
						style="
							margin-top: 2px;
							width: 70.25pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							${i.status ?? ''}
						</p>
					</td>
					<td
						style="
							margin-top: 2px;
							width: 357.65pt;
							border-top: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							${i.info ?? ''}
						</p>
					</td>
				</tr>
          `
          )
          .join('')}
			</table>
			<p style="margin-top: 1pt; margin-bottom: 1pt; font-size: 12pt">
				<strong><span style="color: #00b0f0">&#xa0;</span></strong>
			</p>
			<p style="margin-top: 1pt; margin-bottom: 1pt; font-size: 12pt">
				<strong
					><span style="color: #00b0f0"
						>Решение диагностики</span
					></strong
				>
			</p>
			<table
				cellspacing="0"
				cellpadding="0"
				style="width: 100%; border-collapse: collapse"
			>
				<tr style="height: 1.35pt">
					<td
						style="
							width: 97pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<h1
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">Категория</span>
						</h1>
					</td>
					<td
						style="
							width: 70.5pt;
							border-top: 2.25pt solid #ffffff;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<h1
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">Статус</span>
						</h1>
					</td>
					<td
						style="
							width: 289.85pt;
							border-top: 2.25pt solid #ffffff;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<h1
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">Сведения</span>
						</h1>
					</td>
					<td
						style="
							width: 57.6pt;
							border-top: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 2.25pt solid #ffffff;
							padding: 1.45pt 5.4pt 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<h2
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								text-align: right;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">Сумма</span>
						</h2>
					</td>
				</tr>

				${jsonObject?.answers
          ?.map(
            (i) =>
              `
			  <tr>
					<td
						style="
							margin-top: 2px;

							width: 97pt;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 1pt solid #0070c0;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
						"
					>
						<h1
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							<span style="color: #0e5563"
								>${i.category ?? ''}</span
							>
						</h1>
					</td>
					<td
						style="
						margin-top: 2px;
							width: 70.5pt;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 1pt solid #0070c0;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							${i.status ?? ''}
						</p>
					</td>
					<td
						style="
						margin-top: 2px;
							width: 289.85pt;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 1pt solid #0070c0;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							${i.info ?? ''}
						</p>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							&#xa0;
						</p>
					</td>
					<td
						style="
							width: 57.6pt;
							border-left: 2.25pt solid #ffffff;
							padding: 1.45pt 5.4pt 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								text-align: right;
								font-size: 8pt;
							"
						>
							<strong
								><span style="color: #ffffff"
									>${i.summ ?? ''}</span
								></strong
							>
						</p>
					</td>
				</tr>
            `
          )
          .join('')}
				<tr>
					<td
						style="
							width: 97pt;
							border-top: 1pt solid #0070c0;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
						"
					>
						<h1
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<span style="color: #0e5563">&#xa0;</span>
						</h1>
					</td>
					<td
						style="
							width: 70.5pt;
							border-top: 1pt solid #0070c0;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							&#xa0;
						</p>
					</td>
					<td
						style="
							width: 289.85pt;
							border-top: 1pt solid #0070c0;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<h2
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								text-align: right;
								font-size: 8pt;
							"
						>
							<span style="color: #355d7e">Итоговая сумма</span>
						</h2>
					</td>
					<td
						style="
							width: 57.6pt;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 2.25pt solid #ffffff;
							padding: 1.45pt 5.4pt 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								text-align: right;
								font-size: 8pt;
							"
						>
							<strong
								><span style="color: #ffffff"
									>${
                    jsonObject.answers?.reduce((accumulator, currentValue) => {
                      return +accumulator + +currentValue.summ;
                    }, 0) ?? 0
                  }</span
								></strong
							>
						</p>
					</td>
				</tr>
			</table>

			<p style="margin-top: 1pt; margin-bottom: 1pt; font-size: 12pt">
				<strong
					><span style="color: #00b0f0">Общие сведение</span></strong
				>
			</p>
			<table
				cellspacing="0"
				cellpadding="0"
				style="width: 100%; border-collapse: collapse"
			>
				<tr>
					<td style="vertical-align: top"></td>
					<td
						style="
							width: 143.7pt;
							border-top: 2.25pt solid #ffffff;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<h1
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">Наименование</span>
						</h1>
					</td>
					<td
						style="
							width: 391.4pt;
							border-top: 2.25pt solid #ffffff;
							border-right: 2.25pt solid #ffffff;
							border-left: 2.25pt solid #ffffff;
							border-bottom: 0.75pt solid #7f7f7f;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #0070c0;
						"
					>
						<h1
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							<span style="color: #ffffff">Сведения</span>
						</h1>
					</td>
				</tr>
				<tr>
					<td
						style="
							border-bottom: 2.25pt solid #ffffff;
							vertical-align: top;
						"
					></td>
					<td
						style="
							width: 143.7pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							ОКЭД
						</p>
					</td>
					<td
						style="
							width: 391.4pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							 ${
                 jsonObject?.actualRegData?.regData?.flRegData?.mainOkeds[0]
                   ?.code ??
                 jsonObject?.actualRegData?.regData?.ulRegData?.mainOkeds[0]
                   ?.name
               }${' '}
              -${' '}
              ${
                jsonObject?.actualRegData?.regData?.flRegData?.mainOkeds[0]
                  ?.name ??
                jsonObject?.actualRegData?.regData?.ulRegData?.mainOkeds[0]
                  ?.name
              }
						</p>
					</td>
				</tr>
				<tr>
					<td
						colspan="2"
						style="
							width: 144pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							Юридический адрес
						</p>
					</td>
					<td
						style="
							width: 391.4pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							 ${
                 jsonObject?.actualRegData?.regData?.flRegData?.ipAddress ??
                 jsonObject?.actualRegData?.regData?.ulRegData?.jurAddress
               }
						</p>
					</td>
				</tr>
				<tr>
					<td
						colspan="2"
						style="
							width: 144pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							Плательщик НДС
						</p>
					</td>
					<td
						style="
							width: 391.4pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							${
                jsonObject?.flRegData?.vatSeries
                  ? `НДС плательщик  от ${
                      jsonObject?.flRegData?.vatRegDate ??
                      jsonObject?.ulRegData?.vatRegDate
                    }, Номер ${
                      jsonObject?.flRegData?.vatNumber ?? null
                    }, Серия ${
                      jsonObject?.flRegData?.vatSeries ??
                      jsonObject?.ulRegData?.vatSeries
                    }`
                  : 'Нет'
              }

						</p>
					</td>
				</tr>
				<tr>
					<td
						colspan="2"
						style="
							width: 144pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							Наличие ККМ
						</p>
					</td>
					<td
						style="
							width: 391.4pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							${
                jsonObject?.flRegData?.kkm || jsonObject?.ulRegData?.kkm
                  ? 'Есть'
                  : 'Нет кассового аппарата'
              }
						</p>
					</td>
				</tr>
				<tr>
					<td
						colspan="2"
						style="
							width: 144pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							Наличие или отсутствие налоговой задолженности
						</p>
					</td>
					<td
						style="
							width: 391.4pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							${jsonObject?.taxDebt ? 'Есть' : 'Нет'}
						</p>
					</td>
				</tr>
				
				<tr>
					<td
						colspan="2"
						style="
							width: 144pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							Сведения о приостановлении (возобновлении)
							предоставления налоговой отчетности
						</p>
					</td>
					<td
						style="
							width: 391.4pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							${jsonObject?.stopped}
						</p>
					</td>
				</tr>
				<tr>
					<td
						colspan="2"
						style="
							width: 144pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							Сотрудники
						</p>
					</td>
					<td
						style="
							width: 391.4pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							${jsonObject?.employees ?? ''}
						</p>
					</td>
				</tr>
			  ${jsonObject?.journal
          ?.map(
            (i) => `
              <tr>
                <td
                  colSpan="2"
                  style="
							width: 144pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
                >
                  <p
                    style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
                  >
                    Отчет ФНО
                  </p>
                </td>
                <td
                  style="
							width: 391.4pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
                >
                  <p
                    style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
                  >
                    ${`Форма ${i.formCode ?? ''} ${
                      i.docPeriod.year ?? ''
                    } г.${' '}
                ${i.docPeriod.period.nameRu ?? ' '} (${
                      i?.status?.nameRu ?? ''
                    })`}
                  </p>
                </td>
              </tr>
           `
          )
          .join('')}

		${
      jsonObject?.saldos?.length > 0 &&
      jsonObject?.saldos
        ?.map(
          (i) => `
		 <tr>
                <td
                  colSpan="2"
                  style="
							width: 144pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
                >
                  <p
                    style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
                  >
                   ${i.ruName ?? ''}
                  </p>
                </td>
                <td
                  style="
							width: 391.4pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
                >
                  <p
                    style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
                  >
                   Сальдо ${i.tax ?? ''} | Пеня ${i.penalty ?? 0} | Штраф ${
            i.fine ?? 0
          }
                  </p>
                </td>
              </tr>
        `
        )
        .join('')
    }

				<tr>
					<td
						colspan="2"
						style="
							width: 144pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							Отчет ФНО&#xa0; 100.00, 200
							<span style="font-family: Calibri">(</span>за
							последний отчетный период)
						</p>
					</td>
					<td
						style="
							width: 391.4pt;
							border: 2.25pt solid #ffffff;
							padding: 1.45pt 4.28pt;
							vertical-align: top;
							background-color: #f2f2f2;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							Сдан
						</p>
					</td>
				</tr>

				<tr style="height: 0pt">
					<td style="width: 0.3pt"></td>
					<td style="width: 154.5pt"></td>
					<td style="width: 402.2pt"></td>
				</tr>
			</table>
			<p style="margin-top: 1pt; margin-bottom: 1pt; font-size: 12pt">
				<strong><span style="color: #00b0f0">&#xa0;</span></strong>
			</p>

			<p style="margin-top: 1pt; margin-bottom: 1pt">
				<strong
					><span style="width: 245.25pt; display: inline-block"
						>&#xa0;</span
					></strong
				>
			</p>
			<p style="margin-top: 1pt; margin-bottom: 1pt">
				<strong><span style="color: #355d7e">&#xa0;</span></strong>
			</p>
			<p style="margin-top: 1pt; margin-bottom: 1pt">
				<strong><span style="color: #355d7e">&#xa0;</span></strong>
			</p>
			<table
				cellspacing="0"
				cellpadding="0"
				style="width: 99.7%; border-collapse: collapse"
			>
				<tr style="height: 20.35pt">
					<td
						style="
							width: 403.3pt;
							border-bottom: 1pt solid #0070c0;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							<span style="color: #0e5563">${jsonObject?.byDoneForm ?? ''}</span
							>
						</p>
					</td>
					<td
						style="
							width: 16.5pt;
							border-bottom: 1.5pt solid #c0baba;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							<span style="color: #0e5563">&#xa0;</span>
						</p>
					</td>
					<td
						style="
							width: 154.45pt;
							border-bottom: 1pt solid #0070c0;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
						"
					>
						<p
							style="
								margin-top: 2pt;
								margin-bottom: 0pt;
								font-size: 8pt;
							"
						>
							<span style="color: #0e5563">${jsonObject?.today ?? ''}</span>
						</p>
					</td>
				</tr>
				<tr style="height: 3.75pt">
					<td
						style="
							width: 403.3pt;
							border-top: 1pt solid #0070c0;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<strong
								><span style="color: #00b0f0"
									>(ФИО сотрудника, должность)</span
								></strong
							>
						</p>
					</td>
					<td
						style="
							width: 16.5pt;
							border-top: 2.25pt solid #ffffff;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<strong
								><span style="color: #0e5563"
									>&#xa0;</span
								></strong
							>
						</p>
					</td>
					<td
						style="
							width: 154.45pt;
							border-top: 1pt solid #0070c0;
							padding-top: 0.7pt;
							padding-bottom: 0.7pt;
							vertical-align: top;
						"
					>
						<p
							style="
								margin-top: 1pt;
								margin-bottom: 1pt;
								font-size: 8pt;
							"
						>
							<strong
								><span style="color: #00b0f0"
									>(Дата)</span
								></strong
							>
						</p>
					</td>
				</tr>
			</table>
		</div>
	</body>
</html>
  `;

      const res = await DiagnosticService.getPDF(text);
      if (res) {
        const blob = new Blob([res], { type: 'application/pdf' });
        const link = document.createElement('a');
        const blobUrl = window.URL.createObjectURL(blob);

        link.href = blobUrl;
        link.download = 'ASDASD';

        link.click();
        link.remove();
        message.success('Скачивание завершено');
        setLoading(false);
        window.URL.revokeObjectURL(blobUrl);
      }
    } catch (error) {
      setLoading(false);
      message.error('Не удалось скачать PDF');
    }
  };

  return (
    <Drawer visible={visible} onClose={drawerClose} width="840px">
      <div id="text-area" className="document_diagnostic">
        <div className="main_title first">Диагностика</div>
        <div className="main_info">
          <div className="column_name">Наименование компании</div>
          <div className="column_value">
            {jsonObject?.actualRegData?.regData?.names?.ru.name}
          </div>
          <div className="column_name">Руководитель</div>
          <div className="column_value">
            {jsonObject?.actualRegData?.regData?.names?.ru?.fio !== ''
              ? jsonObject?.actualRegData?.regData?.names?.ru?.fio
              : jsonObject?.actualRegData?.regData?.ulRegData?.director?.nameRu}
          </div>
          <div className="column_name">ИИН/БИН</div>
          <div className="column_value">
            {jsonObject?.actualRegData?.regData?.iin}
          </div>
          <div className="column_name">Режим налогообложения</div>
          <div className="column_value">{jsonObject?.tax_regim}</div>
        </div>
        <div className="main_title second">Общие сведение</div>

        <div className="common_info">
          <div className="column_name">Наименование</div>
          <div className="column_name">Сведения</div>
          <div className="column_value">ОКЭД</div>
          <div className="column_value">
            {jsonObject?.actualRegData?.regData?.flRegData?.mainOkeds[0]
              ?.code ??
              jsonObject?.actualRegData?.regData?.ulRegData?.mainOkeds[0]
                ?.code}{' '}
            -{' '}
            {jsonObject?.actualRegData?.regData?.flRegData?.mainOkeds[0]
              ?.name ??
              jsonObject?.actualRegData?.regData?.ulRegData?.mainOkeds[0]?.name}
          </div>
          <div className="column_value">Юридический адрес</div>
          <div className="column_value">
            {jsonObject?.actualRegData?.regData?.flRegData?.ipAddress ??
              jsonObject?.actualRegData?.regData?.ulRegData?.jurAddress}
          </div>
          <div className="column_value">Плательщик НДС</div>
          <div className="column_value">
            {jsonObject?.flRegData?.vatSeries
              ? `НДС плательщик  от ${
                  jsonObject?.flRegData?.vatRegDate ??
                  jsonObject?.ulRegData?.vatRegDate
                }, Номер ${jsonObject?.flRegData?.vatNumber ?? null}, Серия ${
                  jsonObject?.flRegData?.vatSeries ??
                  jsonObject?.ulRegData?.vatSeries
                }`
              : 'Нет'}
          </div>
          <div className="column_value">Наличие ККМ</div>
          <div className="column_value">
            {jsonObject?.flRegData?.kkm || jsonObject?.ulRegData?.kkm
              ? 'Есть'
              : 'Нет кассового аппарата'}
          </div>
          <div className="column_value">
            Наличие или отсутствие налоговой задолженности
          </div>
          <div className="column_value">
            {jsonObject?.taxDebt ? 'Есть' : 'Нет'}
          </div>

          <div className="column_value">
            Сведения о приостановлении (возобновлении) предоставления налоговой
            отчетности
          </div>
          <div className="column_value">{jsonObject?.stopped}</div>
          <div className="column_value">Сотрудники</div>
          <div className="column_value">{jsonObject?.employees}</div>
          {jsonObject?.journal?.length > 0 &&
            jsonObject?.journal?.map((i) => (
              <>
                <div className="column_value">Отчет ФНО</div>
                <div className="column_value">
                  Форма {i.formCode} {i.docPeriod.year} г.{' '}
                  {i.docPeriod.period.nameRu ?? null} ({i?.status?.nameRu})
                </div>
              </>
            ))}

          {jsonObject?.saldos?.length > 0 &&
            jsonObject?.saldos?.map((i) => (
              <>
                <div className="column_value">{i.ruName}</div>
                <div className="column_value">
                  Сальдо {i.tax} | Пеня {i.penalty} | Штраф {i.fine}
                </div>
              </>
            ))}
        </div>
        <div className="main_title second">Результат диагностики</div>

        <div className="common_info diagnostic_results">
          <div className="column_name">Категория</div>
          <div className="column_name">Статус</div>
          <div className="column_name">Сведения</div>
          {jsonObject?.results?.map((i) => (
            <>
              <div className="column_value blue">{i.category}</div>
              <div className="column_value">{i.status}</div>
              <div className="column_value">{i.info}</div>
            </>
          ))}
        </div>

        <div className="main_title second">Решение диагностики</div>

        <div className="common_info diagnostic_answer">
          <div className="column_name">Категория</div>
          <div className="column_name">Статус</div>
          <div className="column_name">Сведения</div>
          <div className="column_name bg_cm">Сумма</div>
          {jsonObject?.answers?.map((i) => (
            <>
              <div className="column_value bold_darkblue_text bg_white border">
                {i.category}
              </div>
              <div className="column_value border">{i.status}</div>
              <div className="column_value border">{i.info}</div>
              <div className="column_value bg_cm">{i.summ}</div>
            </>
          ))}

          <div className="column_value bg_white" />
          <div className="column_value bg_white" />
          <div className="column_value bold_darkblue_text">Итоговая сумма</div>
          <div className="column_value bg_cm">
            {jsonObject.answers?.reduce((accumulator, currentValue) => {
              return +accumulator + +currentValue.summ;
            }, 0)}
          </div>
        </div>
        <div className="common_info text">
          <div className="simple">{jsonObject?.byDoneForm}</div>
          <div className="simple">{jsonObject?.today}</div>
          <div className="border height" />
          <div className="border height" />
          <div className="blue">(ФИО сотрудника, должность)</div>
          <div className="blue">(Дата)</div>
        </div>
      </div>

      <Button
        onClick={() => {
          downloadPDF();
        }}
        disabled={loading}
        type="primary"
      >
        Скачать PDF
      </Button>
    </Drawer>
  );
}

export { DiagnosticResult };
